import _regeneratorRuntime from "/workspace/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Repo } from '@aragon/connect-core';
export function parseRepo(_x, _x2) {
  return _parseRepo.apply(this, arguments);
}

function _parseRepo() {
  _parseRepo = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(result, organization) {
    var _a, _b, _c, _d, _e, _f, _g, repo, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            repo = (_b = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.app) === null || _b === void 0 ? void 0 : _b.repo;

            if (repo) {
              _context.next = 3;
              break;
            }

            throw new Error('Unable to parse repo.');

          case 3:
            data = {
              address: repo === null || repo === void 0 ? void 0 : repo.address,
              artifact: (_c = repo === null || repo === void 0 ? void 0 : repo.lastVersion) === null || _c === void 0 ? void 0 : _c.artifact,
              contentUri: (_d = repo === null || repo === void 0 ? void 0 : repo.lastVersion) === null || _d === void 0 ? void 0 : _d.contentUri,
              manifest: (_e = repo === null || repo === void 0 ? void 0 : repo.lastVersion) === null || _e === void 0 ? void 0 : _e.manifest,
              name: repo === null || repo === void 0 ? void 0 : repo.name,
              registry: (_f = repo === null || repo === void 0 ? void 0 : repo.registry) === null || _f === void 0 ? void 0 : _f.name,
              registryAddress: (_g = repo === null || repo === void 0 ? void 0 : repo.registry) === null || _g === void 0 ? void 0 : _g.address
            };
            return _context.abrupt("return", Repo.create(data, organization));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _parseRepo.apply(this, arguments);
}